<template>
  <div class="secure-buy">
    <div class="logo-shield">
      <img
        src="@/assets/images/secure-login.svg"
        alt="logo-secure">
    </div>
    <div class="text-secure-buy">
      <h1>Compra segura.</h1>
      <p>Garantizamos la seguridad de tu compra y su información</p>
    </div>
    <div class="first-logos">
      <img
        src="@/assets/images/mc_vrt_pos.svg"
        alt="logo-mastercard">
      <img
        src="@/assets/images/visa.svg"
        alt="logo-visa">
      <img
        src="@/assets/images/american.svg"
        alt="logo-amercian-express">
    </div>
    <div class="first-logos">
      <img
        style="width: 100px; height: 25px"
        src="@/assets/images/logo-openpay.png"
        alt="logo-openpay">
      <img
        style="height: 60px; width: 80px"
        src="@/assets/images/paypal.svg"
        alt="logo-visa">
    </div>
  </div>
</template>

<script>
export default {
  name: 'MtSecureBuy'
}
</script>

<style lang="scss" scoped>

  .secure-buy{
    background-color: white;
    border-radius: 2px;
    padding: 0 5px;
    .logo-shield{
      position: relative;
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: center;
      img{
        position: absolute;
        top: -20px;
        height: 60px;
      }
    }
    .text-secure-buy{
      text-align: center;
      h1{
        @include font-primary(16px, bold);
        color: $roseHeader;
      }
      p{
        @include font-primary(12px, regular);
        color: #777777;
      }
    }
    .first-logos{
      display: flex;
      align-items: center;
      justify-content: space-around;
      height: 60px;
      img{
        width: 60px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/_shared/mt-secure-buy.vue